<div class="d-flex justify-content-center">
  <div class="col-12">
    <form name="editForm" novalidate (ngSubmit)="save()" [formGroup]="editForm">
      <h2 id="jhi-job-heading" data-cy="JobCreateUpdateHeading" jhiTranslate="recruitmentApp.job.home.createOrEditLabel">
        Create or edit a Job
      </h2>
      <hr />
      <div>
        <jhi-alert-error></jhi-alert-error>

        @if (editForm.controls.id.value !== null) {
          <div class="mb-3" style="display: none">
            <label class="form-label" for="field_id" jhiTranslate="recruitmentApp.job.id">ID</label>
            <input type="number" class="form-control" name="id" id="field_id" data-cy="id" formControlName="id" [readonly]="true" />
          </div>
        }

        <div class="mb-3">
          <label class="form-label" for="field_image" jhiTranslate="recruitmentApp.job.image">Image</label>
          <div>
            @if (editForm.get('image')!.value) {
              <img
                [src]="'data:' + editForm.get('imageContentType')!.value + ';base64,' + editForm.get('image')!.value"
                style="max-height: 100px"
                alt="job"
              />
            }
            @if (editForm.get('image')!.value) {
              <div class="form-text text-danger clearfix">
                <span class="pull-start">{{ editForm.get('imageContentType')!.value }}, {{ byteSize(editForm.get('image')!.value!) }}</span>
                <button
                  type="button"
                  (click)="clearInputImage('image', 'imageContentType', 'file_image')"
                  class="btn btn-secondary btn-xs pull-end"
                >
                  <fa-icon icon="times"></fa-icon>
                </button>
              </div>
            }
            <input
              type="file"
              id="file_image"
              data-cy="image"
              (change)="setFileData($event, 'image', true)"
              accept="image/*"
              jhiTranslate="entity.action.addimage"
            />
          </div>
          <input type="hidden" class="form-control" name="image" id="field_image" data-cy="image" formControlName="image" />
          <input
            type="hidden"
            class="form-control"
            name="imageContentType"
            id="field_imageContentType"
            formControlName="imageContentType"
          />
        </div>

        <div class="mb-3">
          <label class="form-label required" for="field_title" jhiTranslate="recruitmentApp.job.title">Title</label>
          <input type="text" class="form-control" name="title" id="field_title" data-cy="title" formControlName="title" />
          @if (editForm.get('title')!.invalid && (editForm.get('title')!.dirty || editForm.get('title')!.touched)) {
            <div>
              @if (editForm.get('title')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
              @if (editForm.get('title')?.errors?.maxlength) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.maxlength" [translateValues]="{ max: '200' }"
                  >This field cannot be longer than 200 characters.</small
                >
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required" for="field_shortDescription" jhiTranslate="recruitmentApp.job.shortDescription"
            >Short Description</label
          >
          <textarea
            rows="4"
            class="form-control"
            name="shortDescription"
            id="field_shortDescription"
            data-cy="shortDescription"
            formControlName="shortDescription"
          ></textarea>
          @if (
            editForm.get('shortDescription')!.invalid &&
            (editForm.get('shortDescription')!.dirty || editForm.get('shortDescription')!.touched)
          ) {
            <div>
              @if (editForm.get('shortDescription')?.errors?.maxlength) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.maxlength" [translateValues]="{ max: '500' }"
                  >This field cannot be longer than 500 characters.</small
                >
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required" for="field_description" jhiTranslate="recruitmentApp.job.description">Description</label>
          <quill-editor name="description" id="field_description" data-cy="description" formControlName="description" />
          @if (editForm.get('description')!.invalid && (editForm.get('description')!.dirty || editForm.get('description')!.touched)) {
            <div>
              @if (editForm.get('description')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
            </div>
          }
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label required" for="field_eduQualify" jhiTranslate="recruitmentApp.job.eduQualify">Edu Qualify</label>
            <select class="form-select" name="eduQualify" formControlName="eduQualify" id="field_eduQualify" data-cy="eduQualify">
              <option [ngValue]="null">{{ 'recruitmentApp.education.null' | translate }}</option>
              @for (education of educationValues; track $index) {
                <option [value]="education">{{ 'recruitmentApp.education.' + education | translate }}</option>
              }
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label required" for="field_eduQualifyMax" jhiTranslate="recruitmentApp.job.eduQualifyMax"
              >Edu Qualify Max</label
            >
            <select
              class="form-select"
              name="eduQualifyMax"
              formControlName="eduQualifyMax"
              id="field_eduQualifyMax"
              data-cy="eduQualifyMax"
            >
              <option [ngValue]="null">{{ 'recruitmentApp.education.null' | translate }}</option>
              @for (education of educationValues; track $index) {
                <option [value]="education">{{ 'recruitmentApp.education.' + education | translate }}</option>
              }
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label required" for="field_experienceYear" jhiTranslate="recruitmentApp.job.experienceYear"
              >Experience Year</label
            >
            <select
              class="form-select"
              aria-label="Experience Year"
              name="experienceYear"
              id="field_experienceYear"
              data-cy="experienceYear"
              formControlName="experienceYear"
            >
              <option [ngValue]="null">--Select--</option>
              <option value="0">0 years</option>
              <option value="1">1 years</option>
              <option value="2">2 years</option>
              <option value="3">3 years</option>
              <option value="4">4 years</option>
              <option value="5">5 years</option>
              <option value="6">6 years</option>
              <option value="7">7 years</option>
              <option value="8">8 years</option>
              <option value="9">9 years</option>
              <option value="10">10 years</option>
              <option value="11">11 years</option>
              <option value="12">12 years</option>
              <option value="13">13 years</option>
              <option value="14">14 years</option>
              <option value="15">15 years</option>
              <option value="16">16 years</option>
              <option value="17">17 years</option>
              <option value="18">18 years</option>
              <option value="19">19 years</option>
              <option value="20">20 years</option>
              <option value="21">21 years</option>
              <option value="22">22 years</option>
              <option value="23">23 years</option>
              <option value="24">24 years</option>
              <option value="25">25 years</option>
              <option value="26">26 years</option>
              <option value="27">27 years</option>
              <option value="28">28 years</option>
              <option value="29">29 years</option>
              <option value="30">30 years</option>
            </select>
            @if (
              editForm.get('experienceYear')!.invalid && (editForm.get('experienceYear')!.dirty || editForm.get('experienceYear')!.touched)
            ) {
              <div>
                @if (editForm.get('experienceYear')?.errors?.required) {
                  <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
                }
                <small
                  class="form-text text-danger"
                  [hidden]="!editForm.get('experienceYear')?.errors?.number"
                  jhiTranslate="entity.validation.number"
                  >This field should be a number.</small
                >
              </div>
            }
          </div>
          <div class="col-md-6">
            <label class="form-label required" for="field_experienceYearTo" jhiTranslate="recruitmentApp.job.experienceYearTo"
              >Experience Year To</label
            >
            <select
              class="form-select"
              aria-label="Experience Year To"
              name="experienceYearTo"
              id="field_experienceYearTo"
              data-cy="experienceYearTo"
              formControlName="experienceYearTo"
            >
              <option [ngValue]="null">--Select--</option>
              <option value="0">0 years</option>
              <option value="1">1 years</option>
              <option value="2">2 years</option>
              <option value="3">3 years</option>
              <option value="4">4 years</option>
              <option value="5">5 years</option>
              <option value="6">6 years</option>
              <option value="7">7 years</option>
              <option value="8">8 years</option>
              <option value="9">9 years</option>
              <option value="10">10 years</option>
              <option value="11">11 years</option>
              <option value="12">12 years</option>
              <option value="13">13 years</option>
              <option value="14">14 years</option>
              <option value="15">15 years</option>
              <option value="16">16 years</option>
              <option value="17">17 years</option>
              <option value="18">18 years</option>
              <option value="19">19 years</option>
              <option value="20">20 years</option>
              <option value="21">21 years</option>
              <option value="22">22 years</option>
              <option value="23">23 years</option>
              <option value="24">24 years</option>
              <option value="25">25 years</option>
              <option value="26">26 years</option>
              <option value="27">27 years</option>
              <option value="28">28 years</option>
              <option value="29">29 years</option>
              <option value="30">30 years</option>
            </select>
            @if (
              editForm.get('experienceYearTo')!.invalid &&
              (editForm.get('experienceYearTo')!.dirty || editForm.get('experienceYearTo')!.touched)
            ) {
              <div>
                @if (editForm.get('experienceYearTo')?.errors?.required) {
                  <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
                }
                <small
                  class="form-text text-danger"
                  [hidden]="!editForm.get('experienceYearTo')?.errors?.number"
                  jhiTranslate="entity.validation.number"
                  >This field should be a number.</small
                >
              </div>
            }
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label required" for="field_salaryMin" jhiTranslate="recruitmentApp.job.salaryMin">Salary Min</label>
            <input
              type="number"
              class="form-control"
              name="salaryMin"
              id="field_salaryMin"
              data-cy="salaryMin"
              formControlName="salaryMin"
            />
            @if (editForm.get('salaryMin')!.invalid && (editForm.get('salaryMin')!.dirty || editForm.get('salaryMin')!.touched)) {
              <div>
                @if (editForm.get('salaryMin')?.errors?.required) {
                  <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
                }
                @if (editForm.get('salaryMin')?.errors?.min) {
                  <small class="form-text text-danger" jhiTranslate="entity.validation.min" [translateValues]="{ min: '0' }"
                    >This field should be at least 0.</small
                  >
                }
                @if (editForm.get('salaryMin')?.errors?.max) {
                  <small class="form-text text-danger" jhiTranslate="entity.validation.max" [translateValues]="{ max: '50000' }"
                    >This field cannot be more than 50000.</small
                  >
                }
                <small
                  class="form-text text-danger"
                  [hidden]="!editForm.get('salaryMin')?.errors?.number"
                  jhiTranslate="entity.validation.number"
                  >This field should be a number.</small
                >
              </div>
            }
          </div>
          <div class="col-md-6">
            <label class="form-label required" for="field_salaryLimit" jhiTranslate="recruitmentApp.job.salaryLimit">Salary Limit</label>
            <input
              type="number"
              class="form-control"
              name="salaryLimit"
              id="field_salaryLimit"
              data-cy="salaryLimit"
              formControlName="salaryLimit"
            />
            @if (editForm.get('salaryLimit')!.invalid && (editForm.get('salaryLimit')!.dirty || editForm.get('salaryLimit')!.touched)) {
              <div>
                @if (editForm.get('salaryLimit')?.errors?.required) {
                  <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
                }
                <small
                  class="form-text text-danger"
                  [hidden]="!editForm.get('salaryLimit')?.errors?.number"
                  jhiTranslate="entity.validation.number"
                  >This field should be a number.</small
                >
              </div>
            }
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label required" for="field_industries" style="margin-bottom: 0" jhiTranslate="recruitmentApp.job.industry"
              >Industry</label
            >
            <div id="industryHelpBlock" class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
              Press 'Ctrl' to select multiple options.
            </div>
            <select
              class="form-select"
              id="field_industries"
              data-cy="industry"
              multiple
              name="industries"
              aria-describedby="industryHelpBlock"
              formControlName="industries"
              [compareWith]="compareIndustry"
            >
              @for (industryOption of industriesSharedCollection; track $index) {
                <option [ngValue]="industryOption">{{ industryOption.name }}</option>
              }
            </select>
            @if (editForm.get(['industries'])!.invalid && (editForm.get(['industries'])!.dirty || editForm.get(['industries'])!.touched)) {
              <div>
                @if (editForm.get(['industries'])?.errors?.required) {
                  <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
                }
              </div>
            }
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label required" for="field_citizenship" jhiTranslate="recruitmentApp.job.citizenship">Citizenship</label>
            <select class="form-select" name="citizenship" formControlName="citizenship" id="field_citizenship" data-cy="citizenship">
              <option [ngValue]="null">{{ 'recruitmentApp.citizenship.null' | translate }}</option>
              @for (citizenship of citizenshipValues; track $index) {
                <option [value]="citizenship">{{ 'recruitmentApp.citizenship.' + citizenship | translate }}</option>
              }
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label required" for="field_status" jhiTranslate="recruitmentApp.job.status">Status</label>
            <select class="form-select" name="status" formControlName="status" id="field_status" data-cy="status">
              <option [ngValue]="null">{{ 'recruitmentApp.JobStatus.null' | translate }}</option>
              @for (jobStatus of jobStatusValues; track $index) {
                <option [value]="jobStatus">{{ 'recruitmentApp.JobStatus.' + jobStatus | translate }}</option>
              }
            </select>
            @if (editForm.get('status')!.invalid && (editForm.get('status')!.dirty || editForm.get('status')!.touched)) {
              <div>
                @if (editForm.get('status')?.errors?.required) {
                  <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
                }
              </div>
            }
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label" for="field_expireDate" jhiTranslate="recruitmentApp.job.expireDate">Expired Date</label>
            <div class="d-flex">
              <input
                id="field_expireDate"
                data-cy="expireDate"
                type="datetime-local"
                class="form-control"
                name="expireDate"
                formControlName="expireDate"
                placeholder="YYYY-MM-DD"
              />
            </div>
          </div>
          <div class="col-md-6"></div>
        </div>
      </div>

      <div>
        <button type="button" id="cancel-save" data-cy="entityCreateCancelButton" class="btn btn-secondary" (click)="previousState()">
          <fa-icon icon="ban"></fa-icon>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
        </button>

        <button
          type="submit"
          id="save-entity"
          data-cy="entityCreateSaveButton"
          [disabled]="editForm.invalid || isSaving"
          class="btn btn-primary"
        >
          <fa-icon icon="save"></fa-icon>&nbsp;<span jhiTranslate="entity.action.save">Save</span>
        </button>
      </div>
    </form>
  </div>
</div>
